// client/src/config/banksData.js
// File di configurazione per i dati delle banche non di relazione

export const BANKS_DATA = {
  'ViViBanca Spa': {
    name: 'ViViBanca',
    description: {
      it: "ViViBanca S.p.A. è un gruppo bancario italiano con sede a Torino, attivo su tutto il territorio nazionale attraverso una rete capillare di filiali, agenti e canali digitali. Specializzata nel credito al consumo e nella cessione del quinto dello stipendio e della pensione, ViViBanca ha ampliato la propria operatività verso il segmento delle piccole e medie imprese, offrendo soluzioni di finanziamento e prodotti di raccolta ad alto rendimento destinati a questo segmento. ViViBanca S.p.A. aderisce al Fondo Interbancario di Tutela dei Depositi.",
      en: "ViViBanca S.p.A. is an Italian banking group headquartered in Turin, operating throughout the national territory through a widespread network of branches, agents, and digital channels. Specialized in consumer credit and salary and pension assignment loans, ViViBanca has expanded its operations toward the small and medium-sized enterprise segment, offering financing solutions and high-yield deposit products targeted at this segment. ViViBanca S.p.A. is a member of the Interbank Deposit Protection Fund."
    },
    dataDate: "31/12/2025",
    listed: false,
    cet1: "13,0%",
    tcr: "17,3%",
    totalAssets: "€1.886 milioni",
    totalDeposits: "€1.166 milioni",
    equity: "€108 milioni",
    countryRating: "S&P BBB+ / Moody's Baa2 / Fitch BBB+",
    bankRating: "NR"
  },
  
 'Banca Più': {
    name: 'Banca Più',
    description: {
      it: "Banca Più nasce dall’evoluzione di Banca Privata Leasing, istituto fondato a Reggio Emilia nel 1987 e storicamente attivo nel credito specializzato e nel leasing a supporto di imprese e privati. Nel tempo, la banca ha consolidato un ruolo riconosciuto nel territorio, sviluppando competenze distintive nel finanziamento degli investimenti produttivi e nel supporto alla crescita del tessuto economico locale. Con la nuova denominazione, introdotta nel 2026, Banca Più avvia una fase di sviluppo orientata al rafforzamento delle attività core e all’ampliamento dell’offerta, affiancando al leasing soluzioni di finanziamento per imprese e privati, con un’attenzione crescente all’innovazione e ai servizi digitali. Banca Più aderisce al Fondo Interbancario di Tutela dei Depositi.",
      en: "Banca Più was established through the evolution of Banca Privata Leasing, a financial institution founded in Reggio Emilia in 1987, with a long-standing history in specialized lending and leasing services for businesses and individuals. Over the years, the bank has built a strong reputation in its local market, developing distinctive expertise in financing productive investments and supporting the growth of the regional economy. With its new name, introduced in 2026, Banca Più is entering a new phase of development focused on strengthening its core business and expanding its product offering. Alongside its traditional leasing services, the bank now provides a broader range of financing solutions for businesses and individuals, with an increasing emphasis on innovation and digital services. Banca Più is a member of the Italian Interbank Deposit Protection Fund (Fondo Interbancario di Tutela dei Depositi).",
    },
    dataDate: "31/12/2025",
    listed: false,
    cet1: "17,63%",
    tcr: "19,46%",
    totalAssets: "€484,5 milioni",
    totalDeposits: "€339,5 milioni",
    equity: "€26,1 milioni",
    countryRating: "S&P BBB+ / Moody's Baa2 / Fitch BBB+",
    bankRating: "NR"
  },

  'Allianz Bank Financial Advisors': {
    name: 'Allianz Bank Financial Advisors',
    description: {
      it: "Allianz Bank Financial Advisors S.p.A. è la banca rete italiana del Gruppo Allianz. Da oltre 50 anni si impegna nel soddisfare la clientela privata interessata ai servizi di investimento, posizionandosi tra le prime banche del suo settore in Italia per patrimonio in gestione. Una realtà solida e in costante crescita il cui azionista di riferimento, Allianz SE, è una delle più forti comunità finanziarie al mondo e detiene una solidità certificata dal rating AA dell’agenzia Standard & Poor’s, con outlook stabile dal 2007. Allianz Bank Financial Advisors aderisce al Fondo Interbancario di Tutela dei Depositi.",
      en: "Allianz Bank Financial Advisors S.p.A. is the Italian network bank of the Allianz Group. For over 50 years, it has been committed to meeting the needs of private clients interested in investment services, positioning itself among the leading banks in its sector in Italy in terms of assets under management. It is a solid and steadily growing institution whose main shareholder, Allianz SE, is one of the strongest financial groups in the world and boasts financial strength certified by an AA rating from Standard & Poor’s, with a stable outlook since 2007. Allianz Bank Financial Advisors is a member of the Italian Interbank Deposit Protection Fund (Fondo Interbancario di Tutela dei Depositi).",
    },
    dataDate: "31/12/2025",
    listed: false,
    cet1: "14,5%",
    tcr: "17%",
    totalAssets: "€11,2 miliardi",
    totalDeposits: "€9,6 miliardi",
    equity: "€664 milioni",
    countryRating: "S&P BBB+ / Moody's Baa2 / Fitch BBB+",
    bankRating: "NR"
  },
  'Banca Partner 1': {
    name: 'Banca Partner 1',
    description: {
      it: "Banca Partner 1 è nata nel 1990 a Milano. La banca ha radici storiche ed opera nel mercato europeo.",
      en: "Allianz Bank Financial Advisors S.p.A. is the Italian network bank of the Allianz Group. For over 50 years, it has been committed to meeting the needs of private clients interested in investment services, positioning itself among the leading banks in its sector in Italy in terms of assets under management. It is a solid and steadily growing institution whose main shareholder, Allianz SE, is one of the strongest financial groups in the world and boasts financial strength certified by an AA rating from Standard & Poor’s, with a stable outlook since 2007.",
    },
    dataDate: "31/12/2024",
    listed: false,
    cet1: "17,5%",
    tcr: "21%",
    totalAssets: "€10,7 miliardi",
    totalDeposits: "€9,1 miliardi",
    equity: "€578 milioni",
    countryRating: "S&P BBB+ / Moody's Baa2 / Fitch BBB+",
    bankRating: "NR"
  },
};

// Funzione helper per ottenere i dati di una banca
export const getBankData = (bankName, language = 'it') => {
  let bankData = null;
  
  // Cerca esattamente il nome
  if (BANKS_DATA[bankName]) {
    bankData = BANKS_DATA[bankName];
  } else {
    // Cerca case-insensitive
    const bankNameLower = bankName.toLowerCase();
    const foundKey = Object.keys(BANKS_DATA).find(
      key => key.toLowerCase() === bankNameLower
    );
    
    if (foundKey) {
      bankData = BANKS_DATA[foundKey];
    }
  }
  
  // Se la banca è stata trovata e ha descrizioni multilingua
  if (bankData && typeof bankData.description === 'object') {
    return {
      ...bankData,
      description: bankData.description[language] || bankData.description.it
    };
  }
  
  return bankData;
};

// Funzione per verificare se una banca è configurata
export const isBankConfigured = (bankName) => {
  return getBankData(bankName) !== null;
};